import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  root: {
    flexGrow: 1,
    position: 'relative',
  },
  suggestionsContainerOpen: {
    position: 'absolute',
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    left: 0,
    right: 0,
    zIndex: 1,
    borderRadius: '3px',
    backgroundColor: theme.palette.background.paper,
  },
  suggestionsContainer: {
    position: 'absolute',
    width: '100%',
  },
  suggestion: {
    display: 'block',
  },
  suggestionsList: {
    margin: 0,
    padding: 0,
    border: 'none',
  },
  noResultsFoundContainer: {
    zIndex: 10,
  },
  noResultsFoundText: {
    padding: theme.spacing(1, 2),
  },
}));
